<ion-content class="bg-color ion-content instance">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card class="margin-top-10">
        <mat-card-title class="mc-title">
          <h4 class="mat-title-header">Vendor List</h4>
        </mat-card-title>
        <mat-card-content class="mc-content">
          <div class="table-container">
            <div class="filter-container">
            </div>
            <table mat-table matTableResponsive [dataSource]="vendorDataSource">

              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> ID </th>
                <td mat-cell *matCellDef="let element">{{element.id}} </td>
              </ng-container>

              <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef> First Name </th>
                <td mat-cell *matCellDef="let element">{{element.first_name}} </td>
              </ng-container>

              <ng-container matColumnDef="last_name">
                <th mat-header-cell *matHeaderCellDef> Last Name </th>
                <td mat-cell *matCellDef="let element">{{element.last_name}} </td>
              </ng-container>

              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let element">{{element.email}} </td>
              </ng-container>

              <ng-container matColumnDef="phone_no">
                <th mat-header-cell *matHeaderCellDef> Phone </th>
                <td mat-cell *matCellDef="let element">{{element.phone_no}} </td>
              </ng-container>

              <ng-container matColumnDef="job_title">
                <th mat-header-cell *matHeaderCellDef> Job Title </th>
                <td mat-cell *matCellDef="let element"> {{element.job_title}} </td>
              </ng-container>

              <ng-container matColumnDef="employee">
                <th mat-header-cell *matHeaderCellDef> Employee </th>
                <td mat-cell *matCellDef="let element"> {{element.employee}} </td>
              </ng-container>

              <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef> Company </th>
                <td mat-cell *matCellDef="let element"> {{element.company}} </td>
              </ng-container>

              <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear> Country </th>
                <td mat-cell *matCellDef="let element"> {{element.country}} </td>
              </ng-container>

              <ng-container matColumnDef="last_visited_date">
                <th mat-header-cell *matHeaderCellDef> Last Visited Date </th>
                <td mat-cell *matCellDef="let element">{{element.last_visit_date | date: 'medium'}} </td>
              </ng-container>

              <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef> Created by </th>
                <td mat-cell *matCellDef="let element">{{element.created_by}} </td>
              </ng-container>

              <ng-container matColumnDef="updated_by">
                <th mat-header-cell *matHeaderCellDef> Updated by </th>
                <td mat-cell *matCellDef="let element">{{element.updated_by}} </td>
              </ng-container>

              <ng-container matColumnDef="created_date">
                <th mat-header-cell *matHeaderCellDef> Created Date </th>
                <td mat-cell *matCellDef="let element"> {{element.created_date | date: 'medium'}} </td>
              </ng-container>

              <ng-container matColumnDef="updated_date">
                <th mat-header-cell *matHeaderCellDef> Updated Date </th>
                <td mat-cell *matCellDef="let element">{{element.updated_date | date: 'medium'}} </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
              </ng-container>

              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon class="icon edit" matTooltip="Edit" matTooltipPosition="above"
                    (click)="editVendor(element.id)"> edit </mat-icon>
                  <mat-icon class="icon info" matTooltip="View More" matTooltipPosition="above"
                    (click)="getVendorDetails(element.id)"> info </mat-icon>
                  <mat-icon class="icon delete" matTooltip="Delete" matTooltipPosition="above"
                    (click)="confirmVendorDelete(element.id)"> delete </mat-icon>
                  <mat-slide-toggle color="danger" #toggle [(ngModel)]="element.block"
                    (ngModelChange)="blockVendorToggle($event,element.id)"></mat-slide-toggle>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="vendorDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: vendorDisplayedColumns;"></tr>
            </table>
          </div>

        </mat-card-content>
      </mat-card>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>